import { format, formatDistanceToNow } from 'date-fns'
import { enUS, es } from 'date-fns/locale'

/**
 * Fechas de la línea de tiempo del ticket: relativa a la vista («hace 2 días»)
 * y absoluta al `title`, para que el dato exacto siga a un hover de distancia.
 * `date-fns` ya es dependencia del repo — no se añade librería (goal
 * portal-correcciones-5).
 */

function toDate(value: string): Date | null {
  const d = new Date(value)
  return Number.isNaN(d.getTime()) ? null : d
}

function localeFor(language: string) {
  return language.startsWith('en') ? enUS : es
}

/** «hace 2 días» / «2 days ago». Si la fecha no parsea devuelve el crudo. */
export function formatRelativeDate(value: string, language: string): string {
  const d = toDate(value)
  if (!d) return value
  return formatDistanceToNow(d, { addSuffix: true, locale: localeFor(language) })
}

/** `16/07/2026 13:00` — el formato exacto que ya usaba el hilo de comentarios. */
export function formatAbsoluteDate(value: string): string {
  const d = toDate(value)
  if (!d) return value
  return format(d, 'dd/MM/yyyy HH:mm')
}
